import { TextButton } from '@creditornot/cb-button';
import { cbSemanticCssVars, elevationCss } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Tag } from '@creditornot/cb-tag';
import styled, { keyframes } from 'styled-components';

import { Typography as T } from 'common/typography';

export const Header = styled(T.Heading4)`
  display: flex;
  flex-direction: column;
`;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  padding: 44px 24px 16px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
  gap: 16px;
`;

export const MenuNameTag = styled(Tag).attrs({ size: 'small', variant: 'lightBlack' })``;

export const StyledTextButton = styled(TextButton)`
  font-weight: bold;
  margin-block-end: 8px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 70px;
  gap: 24px;
  flex-direction: column;
`;

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
`;

export const ButtonsContainer = styled.div`
  ${elevationCss(16)}
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  display: flex;
  justify-content: flex-end;
  position: fixed;
  gap: 16px;
  animation: ${slideUp} both cubic-bezier(0, 0.04, 0, 0.95);
  animation-duration: 400ms;
  background-color: ${color.bg};
`;
